import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function GallerySection() {
  const images = [{
    url: 'https://cdn.magicpatterns.com/uploads/rRbCBuAXaPKPJNeJ5oZqaF/image0.jpg',
    className: 'col-span-1 md:col-span-2 row-span-2 min-h-[300px] md:min-h-0',
    alt: 'Boardroom with glass partitions and skylight'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/b2mQa5JKcz2BqrzFoDpzsV/image2.jpg',
    className: 'col-span-1 min-h-[250px]',
    alt: 'Kitchen and bar area with natural light'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/f3DzJ67DVdLWZFaW4W2Xaj/image3.jpg',
    className: 'col-span-1 min-h-[250px]',
    alt: 'Architectural staircase with glass wall'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/9ojyaXpo3GfvpBypeojHi4/image9.jpg',
    className: 'col-span-1 min-h-[250px]',
    alt: 'Aerial view of 11 Northcote Street'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/vzvx3miBPTm73FBBxvJKNZ/image10.jpg',
    className: 'col-span-1 md:col-span-2 min-h-[250px] md:min-h-[300px]',
    alt: 'Aerial view of Richmond precinct and Melbourne CBD'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section id="gallery" className="py-24 md:py-32 bg-brand-surface" data-id="element-36">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-12 md:mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6" data-id="element-38">
          <div data-id="element-39">
            <h2 className="font-heading text-5xl md:text-6xl text-white mb-4 uppercase" data-id="element-40">
              The Property
            </h2>
            <div className="w-12 h-0.5 bg-brand-gold" data-id="element-41"></div>
          </div>
          <p className="text-brand-muted max-w-md font-light text-sm leading-relaxed" data-id="element-42">
            Impeccably designed spaces that blend contemporary aesthetics with
            functional commercial utility across three levels.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-43">
          {images.map((img, index) => <motion.div key={index} variants={itemVariants} className={`relative overflow-hidden group bg-brand-black cursor-pointer ${img.className}`} data-id="element-44">
              <img src={img.url} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" data-id="element-45" />
              <div className="absolute inset-0 bg-brand-black/10 group-hover:bg-transparent transition-colors duration-500" data-id="element-46"></div>
              <div className="absolute inset-0 border border-transparent group-hover:border-brand-gold/40 transition-colors duration-500 pointer-events-none" data-id="element-47"></div>
            </motion.div>)}
        </motion.div>

        {/* Image count */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-brand-muted/50 text-xs tracking-widest uppercase text-right mt-6" data-id="element-48">
          5 Images
        </motion.p>
      </div>
    </section>;
}